import {
  ComparisonOperators,
  ComparisonValue,
  LogicalOperator,
} from '../api/octopus/models/criteria';
import { WorkflowActionOperationType } from '../api/octopus/models/workflow-action';

export enum WorkflowActionTypes {
  Triggering = 1,
  Branching = 2,
  UpdateFields = 3,
}

export enum WorkflowActionFields {
  WorkflowResult = 'Workflow/Result',
}

export interface WorkflowActionSearch {
  key?: string;
  action?: number;
  parentWorkflowKey?: string;
  workflowTaskTemplateKey?: string;
}

export interface WorkflowActionOperationProperty {
  type: number;
  data: string;
  fieldName?: string | null;
}

export type WorkflowActionConditions =
  | { [field: string]: ComparisonValue }
  | { [K in LogicalOperator]?: { [field: string]: ComparisonValue }[] };

export interface WorkflowActionProperty {
  key: string | null;
  parentWorkflowKey: string;
  action: number;
  conditions?: WorkflowActionConditions;
  operations?: WorkflowActionOperationProperty[];
}

export function extractBranchingOutcomeName(
  action: WorkflowActionProperty,
): string {
  if (
    !action.conditions ||
    !(WorkflowActionFields.WorkflowResult in action.conditions)
  ) {
    return '';
  }
  const conditions = action.conditions as Record<string, ComparisonValue>;
  return (
    conditions[WorkflowActionFields.WorkflowResult]?.[
      ComparisonOperators.Equals
    ] ?? ''
  );
}

export function extractLinkedWorkflowKey(
  action: WorkflowActionProperty,
): string | null {
  return (
    action.operations?.find(
      (operation) =>
        operation.type === WorkflowActionOperationType.StartWorkflow,
    )?.data ?? null
  );
}
